module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('d-select', {
    attrs: {
      "items": _vm.subsForSelect,
      "itemsSelected": [],
      "multiple": false,
      "showSelectedUsers": false,
      "placeholder": _vm.placeholder,
      "addClass": _vm.addClass,
      "isLoading": _vm.isLoading
    },
    on: {
      "add": _vm.onAdd
    },
    scopedSlots: _vm._u([{
      key: "occupied-item",
      fn: function(ref) {
        var item = ref.item;

        return [(item.default_thumb_url) ? _c('img', {
          attrs: {
            "src": item.default_thumb_url,
            "alt": ""
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "active-events-sub__meta"
        }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
          staticClass: "active-events-sub__busy",
          attrs: {
            "title": item.occupiedTitles
          }
        }, [_c('span', {
          staticClass: "icon-warning"
        }), _vm._v("\n        " + _vm._s(item.occupiedLabel) + "\n      ")])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b7f02108!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectSubsActiveEvents.vue
// module id = 2103
// module chunks = 1